<template>
  <PlatformHome v-if="isPlatform" />
  <CustomPage v-else :slug="slug" />
</template>

<script>
// Renders every visitor page, so the page stays mounted under the work overlay.
// '/' on the platform host shows the marketing page instead.
import CustomPage from '@/views/CustomPage.vue'
import PlatformHome from '@/views/PlatformHome.vue'
import { isTenantHost } from '@/utils/tenantUtils'

export default {
  name: 'HomeGate',
  components: { CustomPage, PlatformHome },
  props: {
    slug: { type: String, default: '_home' }
  },
  computed: {
    isPlatform() {
      return this.slug === '_home' && !isTenantHost()
    }
  }
}
</script>
